import { withViewer } from '../../../external/common/hoc/with-viewer';
import AppRoot from '../../../external/tag-cloud-widget/containers/app-root';

export default withViewer(AppRoot);
